import { defineStore } from 'pinia'

type Options = {
  message: string
  timeout?: number
  backgroundColor?: string
  buttonColor?: string
}

export const useSnackBarStore = defineStore('snackbar', {
  state: () => ({
    isDisplay: false,
    message: '',
    timeout: 2000,
    backgroundColor: 'default',
    buttonColor: 'pink',
  }),
  actions: {
    show(options: Options) {
      const { message, timeout, backgroundColor, buttonColor } = options
      this.isDisplay = true
      this.message = message
      this.timeout = timeout || 2000
      this.backgroundColor = backgroundColor || 'default'
      this.buttonColor = buttonColor || 'pink'
    },
    showError(message: string) {
      this.show({
        message,
        backgroundColor: 'error',
        buttonColor: 'white',
        timeout: -1,
      })
    },
    showSuccess(message: string) {
      this.show({
        message,
        backgroundColor: 'success',
        buttonColor: 'white',
      })
    },
    hide() {
      this.isDisplay = false
    },
  },
})
